<template>
  <div id="app">
    <!-- 登录页面 -->
    <div v-if="!isLoggedIn">
      <router-view />
    </div>

    <!-- 服务空间列表页 -->
    <div v-else-if="isProjectListPage">
      <el-container>
        <el-header class="app-header">
          <div class="logo">Cloud Service</div>
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="user-info">
              <el-avatar :size="32" icon="el-icon-user-solid"></el-avatar>
              <span>{{ userName }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>
        <el-main class="app-main">
          <router-view />
        </el-main>
      </el-container>
    </div>

    <!-- 服务空间内部页面（带左侧菜单） -->
    <el-container v-else>
      <el-header class="app-header">
        <div class="header-left">
          <el-button type="text" @click="backToProjects" class="back-button">
            <i class="el-icon-arrow-left"></i> 返回服务空间列表
          </el-button>
          <div class="logo">{{ currentSpaceName }}</div>
        </div>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="user-info">
            <el-avatar :size="32" icon="el-icon-user-solid"></el-avatar>
            <span>{{ userName }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-container>
        <el-aside width="200px" class="app-aside">
          <el-menu
            router
            :default-active="activeMenu"
            class="el-menu-vertical-demo"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-menu-item :index="`/space/${currentSpaceId}/overview`">
              <i class="el-icon-s-home"></i>
              <span slot="title">概览</span>
            </el-menu-item>
            <el-menu-item :index="`/space/${currentSpaceId}/databases`">
              <i class="el-icon-coin"></i>
              <span slot="title">云数据库</span>
            </el-menu-item>
            <el-menu-item :index="`/space/${currentSpaceId}/functions`">
              <i class="el-icon-s-promotion"></i>
              <span slot="title">云函数</span>
            </el-menu-item>
            <el-menu-item :index="`/space/${currentSpaceId}/storage`">
              <i class="el-icon-folder-opened"></i>
              <span slot="title">云存储</span>
            </el-menu-item>
            <el-menu-item :index="`/space/${currentSpaceId}/sites`">
              <i class="el-icon-monitor"></i>
              <span slot="title">前端网页托管</span>
            </el-menu-item>
            <el-menu-item :index="`/space/${currentSpaceId}/logs`">
              <i class="el-icon-document"></i>
              <span slot="title">API 日志</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="app-main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isLoggedIn: false,
      userName: '',
      activeMenu: ''
    }
  },
  computed: {
    isProjectListPage() {
      return this.$route.path === '/projects';
    },
    currentSpaceId() {
      return this.$route.params.id;
    },
    currentSpaceName() {
      const space = this.$store.state.currentProject;
      return space ? space.name : '服务空间';
    }
  },
  async created() {
    // 先初始化认证状态（从服务器获取最新用户信息）
    await this.$store.dispatch('initAuth');
    // 再检查登录状态
    this.checkLoginStatus();
    // 初始化菜单高亮
    this.activeMenu = this.$route.path;
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path;
      this.checkLoginStatus();
    }
  },
  methods: {
    checkLoginStatus() {
      const token = this.$cookies.get('token');
      this.isLoggedIn = !!token;
      
      if (token) {
        // 优先从 Vuex store 读取用户信息
        const user = this.$store.state.user;
        if (user) {
          this.userName = user.name;
        } else {
          // 如果 store 中没有，再从 Cookie 读取
          const userStr = this.$cookies.get('user');
          if (userStr) {
            try {
              const cookieUser = JSON.parse(userStr);
              this.userName = cookieUser.name;
            } catch (e) {
              console.error('解析用户信息失败:', e);
            }
          }
        }
      }
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout();
      }
    },
    handleLogout() {
      this.$cookies.remove('token');
      this.$cookies.remove('user');
      this.$store.dispatch('logout');
      this.isLoggedIn = false;
      this.$router.push('/login');
    },
    backToProjects() {
      this.$router.push('/projects');
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f7fa;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.el-container {
  height: 100vh;
  overflow: hidden;
}

.app-header {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-button {
  color: #606266;
  font-size: 14px;
}

.back-button:hover {
  color: #409eff;
}

.logo {
  font-size: 18px;
  font-weight: 500;
  color: #409eff;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #606266;
}

.user-info span {
  margin-left: 8px;
}

.app-aside {
  background-color: #545c64;
  height: calc(100vh - 60px);
  position: fixed;
  top: 60px;
  left: 0;
  width: 200px;
  overflow-y: auto;
  z-index: 999;
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  margin-top: 60px;
  margin-left: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 项目列表页面不需要左侧菜单 */
.el-container:not(:has(.app-aside)) .app-main {
  margin-left: 0;
}

.el-menu {
  border-right: none;
}

/* 滚动条样式 */
.app-main::-webkit-scrollbar {
  width: 8px;
}

.app-main::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.app-main::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.app-main::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
